export const enum ProductCardType {
  Accommodation = 'Accommodation',
  Activity = 'Activity',
  Flight = 'Flight',
  Ferry = 'Ferry',
}
